/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Link, Tag, useToast } from '@chakra-ui/react';
import moment from 'moment';
import React, { Dispatch } from 'react';
import { Column } from 'react-table';
import { copyWithFeedback } from '../../helper';
import { ProtocolTrace } from '../../interface/Protocol';
import { ProtocolSessionIdTag } from '../RequestTags';
import { TableContainer } from '../table/TableContainer';
import { ProcessedTrace } from './BKTrace';
import { BKTraceRequest } from './BKTraceRequest';

export const BKTraceTable: React.FC<{
    trace: ProcessedTrace[];
    setSelected: Dispatch<ProcessedTrace>;
    tzOffsetMs: number;
    tzLabel: string;
}> = ({ trace, setSelected, tzOffsetMs, tzLabel }) => {
    if (!trace) return null;
    const toast = useToast();

    const columns = React.useMemo(
        () => [
            {
                Header: `Time (${tzLabel})`,
                accessor: (row: ProcessedTrace) => row.created,
                disableSortBy: false,
                Cell: ({ cell: { value }, row: { original } }: { cell: { value: string }; row: { original: ProcessedTrace } }) => {
                    const time = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS').add(tzOffsetMs, 'ms');
                    return (
                    <span style={{ whiteSpace: 'nowrap' }}>
                        <Tag variant="outline" color="black" title={time.format('YYYY-MM-DD HH:mm:ss.SSS')}>
                            {time.format('HH:mm:ss.SSS')}
                        </Tag>
                        {original.messageOffsetMs !== undefined && Math.abs(original.messageOffsetMs) >= 1000 && (
                            <Tag ml={1} colorScheme="orange" size="sm">
                                {original.messageOffsetMs > 0 ? '+' : ''}{(original.messageOffsetMs / 1000).toFixed(1)}s
                            </Tag>
                        )}
                    </span>
                    );
                },
                width: 1,
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
            {
                Header: 'SID',
                accessor: (row: ProcessedTrace) => row.sessionID,
                disableSortBy: false,
                Cell: ({ row: { original } }: { row: { original: ProcessedTrace } }) => (
                    <span style={{ whiteSpace: 'nowrap' }}>
                        <ProtocolSessionIdTag index={original.sessionIdIndex} />
                    </span>
                ),
                width: 1,
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
            {
                Header: 'Message / Request',
                accessor: (row: ProtocolTrace) => row.message ?? '', // TODO format search string
                disableSortBy: true,
                Cell: ({ row: { original } }: { row: { original: ProcessedTrace } }) => (
                        <div style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                            {original.requests ? (
                                <Link onClick={() => setSelected(original)} style={{ cursor: 'pointer' }}>
                                    <BKTraceRequest request={original.requests[0]} />
                                </Link>
                            ) : (
                                <Link onClick={() => copyWithFeedback(original.message || "", toast)} style={{ cursor: 'default' }}>
                                    {original.message}
                                </Link>
                            )}
                        </div>
                ),
                width: 9999,
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
        ],
        [trace, tzOffsetMs, tzLabel],
    ) as Array<Column<ProcessedTrace>>;

    return (
        <>
            <TableContainer
                columns={columns}
                data={trace}
                showColoredState={false}
                search={{
                    placeholder: 'Search in Log',
                }}
                searchBarStyles={{ paddingLeft: '10px' }}
                defaultPageSize={50}
                
            />
        </>
    );
};
